.root {
  width: 624px;
}

.improvements {
  display: block;
}

.tooltip {
  display: flex;
  float: left;
}

.improvement {
  display: flex;
  flex-direction: row;
  float: left;
  padding: 0 var(--dixa-size-spacer-200);
  margin-right: var(--dixa-size-spacer-200);
  margin-bottom: var(--dixa-size-spacer-200);
  text-wrap: nowrap;
  background: var(--dixa-color-neutral-000);

  &Emoji {
    display: inline-block;
    margin-right: var(--dixa-size-spacer-100);
  }
}
